module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "dedication",
      "id": "_idContainer006",
      "role": "doc-dedication"
    }
  }, [_c('p', {
    staticClass: "pl-center"
  }, [_vm._v("To the men and women of the NYPD who protect and serve the vibrant city of New York.")]), _vm._v(" "), _c('p', {
    staticClass: "pl-center"
  }, [_vm._v("To my fellow authors, Lynette, Dana, Laura, Lenora, Val, Sharon, Shirlee and Maggie—thank you for your support and patience with me.")]), _vm._v(" "), _c('p', {
    staticClass: "pl-center"
  }, [_vm._v("To my editors, Emily Rodmell and Tina James—I  so appreciate all you do for me and the books.")]), _vm._v(" "), _c('p', {
    staticClass: "pl-center"
  }, [_vm._v("And to my faithful friends Leah Vale and Jessie Smith for reading every word and believing in me.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0a29feed","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dedication.vue
// module id = 75
// module chunks = 0